<div class="bg-white border-b border-gray-200">
    <div class="container-fluid px-4 py-4">
        <div class="flex flex-col sm:flex-row sm:items-center gap-2">
            <span class="text-xl font-semibold text-gray-900">
                Free Tier
            </span>
            <a class="text-sm font-medium text-blue-600 hover:text-blue-700 transition-colors" [routerLink]="['/', 'subscription']">
                - Upgrade your subscription
            </a>
        </div>
    </div>
</div>